import type { TeamSummary } from "@oracus/shared/api/teams";

import { useTeams } from "../api/teams.api.ts";
import { Badge, Card, Page } from "../components/Page.tsx";

export function Teams() {
  const teams = useTeams();

  return (
    <Page
      title="Teams"
      description="Synced from GitHub. Each team mirrors a GitHub team in the configured org; members and repo ownership come from GitHub. Configure the integration in Settings to enable sync."
    >
      <Card title="All teams">
        {teams.isLoading && <p className="text-sm text-zinc-500">Loading…</p>}
        {teams.data?.teams.length === 0 && (
          <p className="text-sm text-zinc-500">
            No teams synced yet. Configure the GitHub integration in Settings
            and run a sync to populate this list.
          </p>
        )}
        <ul className="divide-y divide-zinc-100">
          {(teams.data?.teams ?? []).map((t) => (
            <TeamRow key={t.id} team={t} />
          ))}
        </ul>
      </Card>
    </Page>
  );
}

function TeamRow({ team }: { team: TeamSummary }) {
  return (
    <li className="py-3">
      <div className="flex items-center gap-2 text-sm">
        <span className="font-medium text-zinc-900">{team.name}</span>
        <Badge tone="neutral">
          {team.repoCount} repo{team.repoCount === 1 ? "" : "s"}
        </Badge>
        {team.ticketCount > 0 && (
          <Badge tone="info">
            {team.ticketCount} ticket{team.ticketCount === 1 ? "" : "s"}
          </Badge>
        )}
      </div>
      {team.description && (
        <p className="mt-1 text-xs text-zinc-600">{team.description}</p>
      )}
    </li>
  );
}
